import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { SellingPoint } from "../../SellingPoint/index.js";
import { ModuleLayout } from "../Layout/ModuleLayout.js";
import { deriveChildEmphasis, isSplitDisplay } from "../Module.types.js";
import { moduleSellingPointsVariants } from "./ModuleSellingPoints.variants.js";
const ModuleSellingPoints_ModuleSellingPoints = /*#__PURE__*/ forwardRef(function({ sellingPoints: rawPoints, maxColumns, children, ...sectionProps }, ref) {
    const sellingPoints = rawPoints.slice(0, 9);
    const split = isSplitDisplay(sectionProps.display);
    let autoColumns = 3;
    if (1 === sellingPoints.length) autoColumns = 1;
    else if (2 === sellingPoints.length) autoColumns = 2;
    const computedColumns = split ? Math.min(autoColumns, 2) : autoColumns;
    const columns = maxColumns ? Math.min(maxColumns, computedColumns) : computedColumns;
    const { gridWrapper, grid } = moduleSellingPointsVariants({
        columns,
        display: sectionProps.display
    });
    const emphasis = deriveChildEmphasis(sectionProps.emphasis);
    const defaultContent = /*#__PURE__*/ jsx("div", {
        className: gridWrapper(),
        children: /*#__PURE__*/ jsx("div", {
            className: grid(),
            children: sellingPoints.map((sp, i)=>/*#__PURE__*/ jsx(SellingPoint, {
                    ...sp,
                    emphasis: emphasis
                }, sp.heading ?? String(i)))
        })
    });
    return /*#__PURE__*/ jsx(ModuleLayout, {
        ref: ref,
        ...sectionProps,
        children: children ?? defaultContent
    });
});
export { ModuleSellingPoints_ModuleSellingPoints as ModuleSellingPoints };
